// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__dMWph","jpCurrentDate":"JP_Footer_jpCurrentDate__IqsYM","jpFootage":"JP_Footer_jpFootage__nJ7XR","higlight":"JP_Footer_higlight__ze5Xj"};